import dayjs from 'dayjs';

export const formatSubmissionPeriod = (submission: any): string => {
  // For General Expense: Show month/year period
  if (submission.programIsGeneral || (submission.periodMonth && submission.periodYear)) {
    if (!submission.periodMonth || !submission.periodYear) return 'N/A';
    return dayjs()
      .month(submission.periodMonth - 1)
      .year(submission.periodYear)
      .format('MMMM YYYY');
  }
  
  // For Custom Programs: Show program date range
  if (submission.programStartDate && submission.programEndDate) {
    return `${dayjs(submission.programStartDate).format('MMM D, YYYY')} - ${dayjs(submission.programEndDate).format('MMM D, YYYY')}`;
  }
  
  return 'N/A';
};

export const formatPeriod = (month?: number, year?: number): string => {
  if (!month || !year) return 'N/A';
  return dayjs().month(month - 1).year(year).format('MMMM YYYY');
};